import { Button } from "components/buttons/Button";
import styles from "./index.module.scss";
import Sun from "assets/icons/sun.svg?react";
import Moon from "assets/icons/moon.svg?react";
import Laptop from "assets/icons/laptop.svg?react";
import { useCallback } from "react";
import { updateDashboardTheme } from "store/view/slice";
import { ThemeOptions } from "store/view/types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "store/reducers";

export const ThemeSelection: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { theme } = useSelector((state: RootState) => state.view);

    const setTheme = useCallback(
        (theme: ThemeOptions) => {
            dispatch(updateDashboardTheme(theme));
        },
        [dispatch]
    );

    return (
        <div className={styles.container}>
            <h6>{t("theme-selection:appearance")}</h6>
            <div className={styles.buttons}>
                <Button
                    type="badge-tertiary"
                    iconLeft={<Sun />}
                    onClick={() => setTheme(ThemeOptions.Light)}
                    isActive={theme === ThemeOptions.Light}
                >
                    {t("theme-selection:light")}
                </Button>
                <Button
                    type="badge-tertiary"
                    iconLeft={<Moon />}
                    onClick={() => setTheme(ThemeOptions.Dark)}
                    isActive={theme === ThemeOptions.Dark}
                >
                    {t("theme-selection:dark")}
                </Button>
                <Button
                    type="badge-tertiary"
                    iconLeft={<Laptop />}
                    onClick={() => setTheme(ThemeOptions.Device)}
                    isActive={theme === ThemeOptions.Device}
                >
                    {t("theme-selection:device")}
                </Button>
            </div>
        </div>
    );
};
